<!--View Mode-->
@if (action == 'view') {
  <td class="tableColumn">{{tenant.id}}</td>
}
@if (action == 'view') {
  <td class="tableColumn">{{tenant.name}}</td>
}
@if (action == 'view') {
  <td class="tableColumn">{{tenant.accessKey}}</td>
}
@if (action == 'view' && isAdminUser) {
  <td class="tableColumn">
    <div class="{{isActiveCssClass}}">
      @if (actionHappening != 'disable') {
        <input class="form-check-input" type="checkbox" id="cbIsActive" [disabled]="!isAdminUser || isLoading" [checked]="tenant.isActive" (change)="disableTenant('view')" [(ngModel)]="tenant.isActive">
      }
    </div>
  </td>
}
@if (action == 'view' && !isAdminUser) {
  <td class="tableColumn">
    {{tenant.isActive}}
  </td>
}
@if (action == 'view') {
  <td class="tableColumn">{{tenant.updateDate | date:'yyyy-MM-dd HH:mm:ss'}}</td>
}
@if (action == 'view') {
  <td>
    <button type="button" class="m-1" (click)="updateAction('update')"><i class="bi bi-pencil-square" title="Update"></i></button>
  </td>
}
@if (action == 'view' && isAdminUser) {
  <td class="tableColumn">
    @if (isAdminUser) {
      <button type="button" class="m-1" (click)="openConfirmationDialog()" [disabled]="isLoading">@if (actionHappening != 'delete') {
        <i class="bi bi-archive-fill" title="Delete"></i>
        }@if (actionHappening == 'delete') {
        <i class="spinner-border spinner-border-sm"></i>
      }</button>
    }
  </td>
}
<!--<td *ngIf="action == 'view'">
<button type="button" class="m-1" (click)="billinDets()"><i class="bi bi-receipt" title="Billing"></i></button>
</td>-->


<!--Update Mode-->
@if (action == 'update') {
  <td class="tableColumn">{{tenant.id}}</td>
}
@if (action == 'update') {
  <td class="tableColumn">
    <input type="text" appTrim [(ngModel)]="tenant.name" name="txtTenantName" id="txtTenantName" required #txtTenantName="ngModel" pattern="[a-zA-Z0-9 ]{1,50}" minlength="1" maxlength="50" />
    @if (txtTenantName.invalid && (txtTenantName.dirty || txtTenantName.touched)) {
      <div class="tableColumn">
        @if (txtTenantName.errors?.['required']) {
          <span> Name is required </span>
        }
        @if (txtTenantName.errors?.['pattern'] || txtTenantName.errors?.['minlength'] || txtTenantName.errors?.['maxlength']) {
          <span> Only Alphanumericals of max length 50 are allowed </span>
        }
      </div>
    }
  </td>
}
@if (action == 'update') {
  <td class="tableColumn">{{tenant.accessKey}}</td>
}
@if (action == 'update') {
  <td>{{tenant.isActive}}</td>
}
@if (action == 'update') {
  <td>{{tenant.updateDate | date:'yyyy-MM-dd HH:mm:ss'}}</td>
}
@if (action == 'update') {
  <td>
    <button type="button" class="m-1" (click)="updateTenant('view')" [disabled]="isLoading">
      @if (actionHappening != 'update') {
        <i class="bi bi-check2-square" title="Update"></i>
      }
      @if (actionHappening == 'update') {
        <i class="spinner-border spinner-border-sm"></i>
      }
    </button>
    <button type="button" class="m-1" (click)="cancelEdit('view')" [disabled]="isLoading"><i class="bi bi-x-square-fill" title="Cancel"></i></button>
  </td>
}
@if (action == 'update' && isAdminUser) {
  <td class="tableColumn">
    @if (isAdminUser) {
      <button type="button" class="m-1" (click)="openConfirmationDialog()" [disabled]="isLoading">@if (actionHappening != 'delete') {
        <i class="bi bi-archive-fill" title="Delete"></i>
        }@if (actionHappening == 'delete') {
        <i class="spinner-border spinner-border-sm"></i>
      }</button>
    }
  </td>
}
<!--<td *ngIf="action == 'update'">
<button type="button" class="m-1" (click)="billinDets()"><i class="bi bi-receipt" title="Billing"></i></button>
</td>-->

@if (action == 'create') {
  <div class="table-responsive-sm">
    <table>
      <tr class="row"><td>Tenant Details</td></tr>
      <tr class="row">
        <td class="col-5 gy-1">Tenant Id <span class="requiredField">*</span></td>
        <td class="col-5 gy-1">
          <input type="text" appTrim [(ngModel)]="tenant.id" name="txtTenantId" id="txtTenantId" placeholder="Tenant Id" required #txtTenantId="ngModel" pattern="[a-zA-Z0-9]{1,20}" minlength="1" maxlength="20" />
        </td>
      </tr>
      @if (txtTenantId.invalid && (txtTenantId.dirty || txtTenantId.touched)) {
        <tr>
          @if (txtTenantId.errors?.['required']) {
            <td> Tenant Id is required </td>
          }
          @if (txtTenantId.errors?.['pattern'] || txtTenantId.errors?.['minlength'] || txtTenantId.errors?.['maxlength']) {
            <td> Only Alphanumericals of max length 20 are allowed </td>
          }
        </tr>
      }
      <tr class="row">
        <td class="col-5 gy-1">Name <span class="requiredField">*</span></td>
        <td class="col-5 gy-1">
          <input type="text" appTrim [(ngModel)]="tenant.name" name="txtTenantName" id="txtTenantName" placeholder="Tenant Name" required #txtTenantName="ngModel" pattern="[a-zA-Z0-9 ]{1,50}" minlength="1" maxlength="50" />
        </td>
      </tr>
      @if (txtTenantName.invalid && (txtTenantName.dirty || txtTenantName.touched)) {
        <tr>
          @if (txtTenantName.errors?.['required']) {
            <td> Name is required </td>
          }
          @if (txtTenantName.errors?.['pattern'] || txtTenantName.errors?.['minlength'] || txtTenantName.errors?.['maxlength']) {
            <td> Only Alphanumericals of max length 50 are allowed </td>
          }
        </tr>
      }
      <tr class="row">
        <td class="col-10 gy-1 ">
          <button type="button" class="m-1" (click)="createTenant('view')" [disabled]="(txtTenantId.invalid || txtTenantName.invalid) || isLoading"> @if (actionHappening != 'create') {
            <i class="bi bi-check" title="Create"></i>
            } @if (actionHappening == 'create') {
            <i class="spinner-border spinner-border-sm"></i>
          }  </button>
          <button type="button" class="m-1" (click)="cancelCreate('view')" [disabled]="isLoading"><i class="bi bi-x-square" title="Cancel"></i></button>
        </td>
      </tr>
    </table>
  </div>
}

<!--Confirmation pop up-->
@if (actionHappening == 'delete') {
  <appPopup [displayStyle]="displayStyle" [entityName]="entityName" (popupOutputEvent)="confirmDelete($event)"></appPopup>
}
